import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ActionSummaryRow from '../../../../xlalerts/common/actions/ActionSummaryRow';
import { selectUserList } from '../../../../../redux/slices/userListSlice/userListSlice';

function NotificationActionCardBody({ action, canDelete }) {
  const users = useSelector(selectUserList);
  return (
    <div>
      <ActionSummaryRow action={action} usersList={users} canDelete={canDelete} />
    </div>

  );
}
NotificationActionCardBody.propTypes = {
  action: PropTypes.objectOf(PropTypes.any).isRequired,
  canDelete: PropTypes.bool.isRequired,
};
export default NotificationActionCardBody;
